import React from 'react';
import type { CompanyPrintInfo } from '@/components/sales-invoice/PrintableSalesInvoice';
import type { DeliveryPrintData } from '@/services/delivery.service';
import type { DeliveryPrintLetterheadVariant } from './DeliveryNotePrintView';
import { EnginePackingListPrint } from '@/components/print/EngineLetterheadPrints';

/** Packing list print — shared pagination engine. */
export function DeliveryPackingListPrintView({
  data,
  companyInfo = { name: 'Company' },
  printVariant = 'letterhead',
  onClose,
}: {
  data: DeliveryPrintData;
  companyInfo?: CompanyPrintInfo;
  printVariant?: DeliveryPrintLetterheadVariant;
  onClose?: () => void;
}) {
  return (
    <EnginePackingListPrint
      data={data}
      companyInfo={companyInfo}
      printVariant={printVariant}
      onClose={onClose}
    />
  );
}
